export const WorkshopPartParameter = {
    CompanyName: 'CompanyName',
    FantasyName: 'FantasyName',
    StoreName: 'StoreName'
};



// WEBPACK FOOTER //
// ./src/constants/workshopPartParameter.js